import React from 'react';
import LazyLoad from 'react-lazyload';
import './PartnerCarousselQ.css';

  
function PartnerCarousselQ() {
  const partnerImages = [
    'l1.png',
    'l2.png',
    'l3.png',
    'l4.png',
    'l5.png',
    'Q1.png',
    'Q2.png',
    'Q3.png',
    'Q4.png',
  ];

  const imageDimensions = {
    height: 100, // Modify the desired height
    width: 130, // Modify the desired width
  };

  return (
    <div className="slider">
      <div className="slide-track">
        {partnerImages.map((image, index) => (
          <LazyLoad key={index} height={imageDimensions.height} offset={100}>
            <div className="slide" key={index}>
              <img
                src={`images/${image}`}
                alt={`Partner ${index + 1}`}
                height={imageDimensions.height}
                width={imageDimensions.width}
              />
            </div>
          </LazyLoad>
        ))}
      </div>
    </div>
  );
}

export default React.memo(PartnerCarousselQ);
